import state from './moduleEntryState.js'
import mutations from './moduleEntryMutations.js'
import actions from './moduleEntryActions.js'
import getters from './moduleEntryGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
